export default class CollaborationSpacesListCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, $mdDialog, $cookies, GlobalConfig, WorkPlanModalSrv, Requests, $sessionStorage) {
    var collaborationSpacesVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId,
    }

    collaborationSpacesVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    collaborationSpacesVm.$sessionStorage = $sessionStorage

    collaborationSpacesVm.mainLabel = 'Espacios de colaboración'
  	collaborationSpacesVm.spaceList = []
  	collaborationSpacesVm.viewLoaded = false;
  	collaborationSpacesVm.gradRoleClass = 'grad-1'
    collaborationSpacesVm.active = GlobalConfig.generals.active
    collaborationSpacesVm.notActive = GlobalConfig.generals.notActive
    collaborationSpacesVm.planningFinish = true
    $scope.classPlanning = ''
    collaborationSpacesVm.feedback = 0
  	collaborationSpacesVm.carouselResponsiveBreakpoints = [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 1920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]

  collaborationSpacesVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')

  collaborationSpacesVm.confirmDeleteSpace = confirmDeleteSpace
  collaborationSpacesVm.updateView = updateView
  collaborationSpacesVm.loadData = loadData
  collaborationSpacesVm.getGeneralsWorkplan = getGeneralsWorkplan
  collaborationSpacesVm.bitacora = bitacora

	activate();

  function activate(){
    if(collaborationSpacesVm.workPlanGeneralList != undefined){
      collaborationSpacesVm.status = collaborationSpacesVm.workPlanGeneralList.wokplanTeacherStatus[0]
      collaborationSpacesVm.stages = collaborationSpacesVm.workPlanGeneralList.stages
      collaborationSpacesVm.inReview = collaborationSpacesVm.status.reviewed
      collaborationSpacesVm.feedback = collaborationSpacesVm.status.feedbackReviewed
      collaborationSpacesVm.workplanTeacherId = collaborationSpacesVm.status.workplanTeacherId
      isPlanning(collaborationSpacesVm.status, collaborationSpacesVm.stages)

      if(collaborationSpacesVm.feedback && !collaborationSpacesVm.planningFinish){
        getListSpacesCollaborationReject()
      }else{
        getListSpacesCollaboration()
      }
    }else{
      getGeneralsWorkplan(post).then((promise) => {
        if(collaborationSpacesVm.feedback && !collaborationSpacesVm.planningFinish){
          getListSpacesCollaborationReject()
        }else{
          getListSpacesCollaboration()
        }
      })
    }

    updateView()
  }

  function getListSpacesCollaboration(){
    WorkPlanSrv.getListSpacesCollaboration.getList(post).$promise.then(
      dataReturn => {
        if (dataReturn.status) {
          loadData(dataReturn.listSpaces)
        }else{
          console.log("Comunications problem")
        }
      },
      data => {
        console.log(data)
      }
    )
  }

  function getListSpacesCollaborationReject(){
    WorkPlanSrv.getListSpacesCollaborationReject.getList(post).$promise.then(
      dataReturn => {
        if (dataReturn.status) {
          loadData(dataReturn.listSpaces)
        }else{
          console.log("Comunications problem")
        }
      },
      data => {
        console.log(data)
      }
    )
  }

  function updateView () {
    collaborationSpacesVm.viewLoaded = false
    $timeout(() => {
      collaborationSpacesVm.viewLoaded = true
    }, 1)
  }

  function loadData(data){
    collaborationSpacesVm.spaceList = data
  }
  
  function confirmDeleteSpace (itemSpace) {   
    let spaceName = itemSpace.nameSpace
    let workplanTeacherActivityId = itemSpace.workplanTeacherActivityId
    $mdDialog.show({
      controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
        let ctrlModalVM = this
        ctrlModalVM.spaceName = spaceName
        ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
        ctrlModalVM.close = function () {
          $mdDialog.hide()
        }
        ctrlModalVM.deleteSpace = function () {
          WorkPlanSrv.disableActivityResearch.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
          .$promise.then(function (dataReturn) {
            if (dataReturn.status) {
              removeSpaceFromCaroussel(itemSpace)
              showDeletedSuccessfully(ctrlModalVM.spaceName)
              WorkPlanIndicatorSrv.setVariable(true)
              $mdDialog.hide()
            } else {
              console.log('Comunications problem with the server')
            }
          }, function (data) {

          })
        }
      }],
      controllerAs: 'ctrlModalVM',
      template: require('./deleteSpaceModal.html'),
      clickOutsideToClose: false
    })
  }

    function showDeletedSuccessfully(spaceName){
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : spaceName,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })      
    }

    function removeSpaceFromCaroussel(itemSpace){
      for(var i in collaborationSpacesVm.spaceList){
        if(collaborationSpacesVm.spaceList[i].workplanTeacherActivityId === itemSpace.workplanTeacherActivityId){
          collaborationSpacesVm.spaceList.splice(i,1)
          updateView()
          break
        }
      }
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          collaborationSpacesVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          collaborationSpacesVm.status = dataReturn.data.wokplanTeacherStatus[0]
          collaborationSpacesVm.stages = dataReturn.data.stages
          collaborationSpacesVm.inReview = collaborationSpacesVm.status.reviewed
          collaborationSpacesVm.feedback = collaborationSpacesVm.status.feedbackReviewed
          collaborationSpacesVm.workplanTeacherId = collaborationSpacesVm.status.workplanTeacherId
          isPlanning(collaborationSpacesVm.status, collaborationSpacesVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      collaborationSpacesVm.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          collaborationSpacesVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == collaborationSpacesVm.active) {
          collaborationSpacesVm.planningFinish = true
          if (collaborationSpacesVm.startDateReview < collaborationSpacesVm.currentDate || status.reviewedFinish == collaborationSpacesVm.active) {
            collaborationSpacesVm.planningFinish = true
          } else if (status.reviewedReject == collaborationSpacesVm.active){
            collaborationSpacesVm.planningFinish = false
          }
        } else {
            collaborationSpacesVm.planningFinish = false
        }
      }else{
        collaborationSpacesVm.planningFinish = true
      }

      $scope.classPlanning = (collaborationSpacesVm.planningFinish ? "disabled" : " ")
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.colaborationSpace,
        workplanTeacherId: collaborationSpacesVm.workplanTeacherId
      }
      entries.title = 'Espacios de colaboración'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }


 }
}

CollaborationSpacesListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', '$mdDialog', '$cookies', 'GlobalConfig', 'WorkPlanModalSrv', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/collaborationSpaces/list/collaborationSpacesListCtrl.js